<script>
    import { onMount } from "svelte";
    import Odometer from "odometer";
    import { refresh_count } from "../../guest";

    export let value = 0;
    export let format = "";
    export let theme = "car";

    let elt;
    let odo;

    function refresh() {
        if (value && odo) {
            odo.update(value);
        }
    }

    $: refresh(value);

    const onClick = () => {
        value += 1;
        if (value > 9) {
            value = 0;
        }
    };

    onMount(() => {
        odo = new Odometer({
            el: elt,
            value: value,
            auto: false,
            format: format,
            theme: theme,
            duration: 500,
        });
        odo.render();
    });
</script>

<article bind:this={elt} on:click={onClick} />

<style>
    :global(.odometer.odometer-theme-car.odometer-animating-down.odometer-animating
            .odometer-ribbon-inner) {
        -webkit-transition: -webkit-transform 0.5s !important;
        -moz-transition: -moz-transform 0.5s !important;
        -ms-transition: -ms-transform 0.5s !important;
        -o-transition: -o-transform 0.5s !important;
        transition: transform 0.5s !important;
    }

    :global(.odometer.odometer-theme-car.odometer-animating-up .odometer-ribbon-inner) {
        -webkit-transition: -webkit-transform 0.5s !important;
        -moz-transition: -moz-transform 0.5s !important;
        -ms-transition: -ms-transform 0.5s !important;
        -o-transition: -o-transform 0.5s !important;
        transition: transform 0.5s !important;
    }
</style>
